module.exports = __webpack_public_path__ + "static/media/City.c85813ba.jpeg";